<template>
  <sweet-modal
    ref="scienceModal"
    title="Science on IH-MSP"
    class="modal-about"
    width="80%"
    @close="onClose"
  >
    <div>
      <p>
        IH-MSP Platform provides outcomes from the implementation of scientific
        and technical advances generated by researchers at the Environmental
        Hydraulics Institute “IHCantabria”. Some of the main scientific
        communications explaining the designed methodologies are listed in the
        following lines:
      </p>
      <vs-list>
        <vs-list-header title="2023" color="success"></vs-list-header>
        <vs-list-item
          icon="check"
          title="Towards blue growth: Multi-use possibilities for the development of emerging sectors in the Brazilian sea"
          subtitle="Weiss, C., Bonetti, J., Scherer, M., Ondiviela, B., Guanche, R., Juanes, J.A. Towards blue growth: Multi-use possibilities for the development of emerging sectors in the Brazilian sea, Ocean & Coastal Management,
Volume 243, 106764
"
        >
          <a
            href="https://doi.org/10.1016/j.ocecoaman.2023.106764"
            target="blank"
            title="Go to link"
          >
            <vs-icon icon="link" color="#00a09e" size="small"></vs-icon>
          </a>
        </vs-list-item>
        <vs-list-header title="2020" color="success"></vs-list-header>
        <vs-list-item
          icon="check"
          title="Climate change effects on marine renewable energy resources and environmental conditions for offshore aquaculture in Europe"
          subtitle="Weiss, C., Menendez, M., Ondiviela, B., Guanche, R., Losada, I.J., Juanes, J.A. ICES Journal of Marine Science, Volume 77, Issue 7-8, Pages 3168–3182"
        >
          <a
            href="https://doi.org/10.1093/icesjms/fsaa226"
            target="blank"
            title="Go to link"
          >
            <vs-icon icon="link" color="#00a09e" size="small"></vs-icon>
          </a>
        </vs-list-item>
        <vs-list-header title="2018" color="success"></vs-list-header>
        <vs-list-item
          icon="check"
          title="A global integrated analysis of open sea fish farming
          opportunities (AQUACULTURE)"
          subtitle=" 2018 Weis, C., Ondiviela, B., Guanche, R., Castellanos, O.F., Juanes,
          J.A. A global integrated analysis of open sea fish farming
          opportunities Aquaculture 497 234 245"
        >
          <a
            href="https://doi.org/10.1016/j.aquaculture.2018.07.054"
            target="blank"
            title="Go to link"
          >
            <vs-icon icon="link" color="#00a09e" size="small"></vs-icon>
          </a>
        </vs-list-item>
        <vs-list-item
          icon="check"
          title="Co-location opportunities for renewable energies
          and aquaculture facilities in the Canary Archipelago (OCEAN & COASTAL MANAGEMENT)"
          subtitle="2018 Weis, C., Ondiviela, B., Guinda, X., Del Jesus, F., González, J., Guanche, R., Juanes, J.A. Co-location opportunities for renewable energies
          and aquaculture facilities in the Canary Archipelago Ocean & Coastal
          Management 166 62 71"
        >
          <a
            href="https://doi.org/10.1016/j.ocecoaman.2018.05.006"
            target="blank"
            title="Go to link"
          >
            <vs-icon icon="link" color="#00a09e" size="small"></vs-icon>
          </a>
        </vs-list-item>
        <vs-list-item
          icon="check"
          title="Development of a Tool to Identify Potential Zones for Offshore
          Aquaculture: A Global Case Study for Greater Amberjack (PROCEEDINGS OF THE ASTME 2018)"
          subtitle="2018 Weis, C., Ondiviela, B., Guanche, R., Castellanos, O.F., Juanes,
          J.A. Development of a Tool to Identify Potential Zones for Offshore
          Aquaculture: A Global Case Study for Greater Amberjack Proceedings of
          the ASME 2018 37th International Conference on Ocean, Offshore and
          Arctic Engineering 77870 1 7 DOI: 10.1115/OMAE2018-77870"
        >
          <a
            href="http://proceedings.asmedigitalcollection.asme.org/proceeding.aspx?articleid=2704498"
            target="blank"
            title="Go to link"
          >
            <vs-icon icon="link" color="#00a09e" size="small"></vs-icon>
          </a>
        </vs-list-item>
        <vs-list-item
          icon="check"
          title="Experimental and Numerical
          Modelling of an Offshore Aquaculture Cage for Open Ocean Waters
          (PROCEEDINGS OF THE ASTME 2018)"
          subtitle="2018 Jurado Fuentes, Alfonso, Sánchez, Patricia, Armesto, J.A.,
          Guanche, R., Ondiviela, B., Juanes, J.A. Experimental and Numerical
          Modelling of an Offshore Aquaculture Cage for Open Ocean Waters
          Proceedings of the ASME 2018 37th International Conference on Ocean,
          Offshore and Arctic Engineering 7760 1 10 doi:10.1115/OMAE2018-77600"
        >
          <a
            href="https://proceedings.asmedigitalcollection.asme.org/proceeding.aspx?articleid=2704578"
            target="blank"
            title="Go to link"
          >
            <vs-icon icon="link" color="#00a09e" size="small"></vs-icon>
          </a>
        </vs-list-item>
        <vs-list-item
          icon="check"
          title="Marine renewable energy potential: A global perspective for
          offshore wind and wave exploitation (ENERGY CONVERSION AND MANAGEMENT)"
          subtitle="2018 Weis, C., Guanche, R., Ondiviela, B., Castellanos, O.F., Juanes,
          J.A. Marine renewable energy potential: A global perspective for
          offshore wind and wave exploitation Energy Conversion and Management
          177 43 54 DOI: 10.1016/j.enconman.2018.09.059"
        >
          <a
            href="https://www.sciencedirect.com/science/article/pii/S0196890418310628"
            target="blank"
            title="Go to link"
          >
            <vs-icon icon="link" color="#00a09e" size="small"></vs-icon>
          </a>
        </vs-list-item>
        <vs-list-header title="2017"></vs-list-header>
        <vs-list-item
          icon="check"
          title="Statistical wave climate projections for coastal impact assessments"
          subtitle="2017 Camus, P., Losada, Í.J., Izaguirre, C., Espejo, A., Menendez, M., Pérez, J. Statistical wave climate projections for coastal impact assessments. Earth's Future. V. 5, p. 918–933. DOI:10.1002/eft2.234"
        >
          <a
            href="https://agupubs.onlinelibrary.wiley.com/doi/full/10.1002/2017EF000609"
            target="blank"
            title="Go to link"
          >
            <vs-icon icon="link" color="#00a09e" size="small"></vs-icon>
          </a>
        </vs-list-item>
      </vs-list>
    </div>
  </sweet-modal>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    autoOpen: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      toggle: "isScienceModalVisible"
    })
  },
  watch: {
    toggle() {
      if (this.toggle) {
        this.$refs.scienceModal.open();
      }
    }
  },
  mounted() {
    if (this.autoOpen) {
      this.$refs.scienceModal.open();
    }
  },
  methods: {
    ...mapActions({
      toggleScience: "toggleScience"
    }),
    onClose() {
      this.toggleScience();
    }
  }
};
</script>
<style scoped>
.modal-science >>> .sweet-modal {
  max-width: 1100px !important;
}
.sweet-modal-overlay {
  background: rgba(0, 0, 0, 0.1);
}

</style>
